import { lazy, Suspense } from "react";
import type { MenuItem } from "./types.ts";

export type MediaViewerItem = {
  /** Media source (resolved through the media pipeline like Image). */
  src: string;
  kind: "image" | "video";
  /** Accessible name / caption (the file name). */
  title: string;
  width?: number;
  height?: number;
  /** Video poster. */
  poster?: string;
  /** Video MIME type ("video/mp4"). */
  mime?: string;
};

export type MediaViewerProps = {
  open: boolean;
  /** The item shown (controlled). */
  index: number;
  items: MediaViewerItem[];
  onClose: () => void;
  onIndexChange: (index: number) => void;
  /** Toolbar actions for the current item (download, copy link…), icon buttons labelled by `label`. */
  actions: MenuItem[];
  /** Translated control labels. */
  labels: { close: string; previous: string; next: string; counter: string };
  testID?: string;
};

const Impl = lazy(() => import("./MediaViewerImpl.tsx"));

/**
 * Full-screen viewer for a message's images and videos: swipe/arrow keys for prev/next, pinch/wheel zoom, toolbar
 * actions. Web: yet-another-react-lightbox (loaded on first open). Native: a paged `TabView` with zoomable images
 * (iOS) / `HorizontalPager` + zoomable Coil images (Android), each with the same toolbar actions.
 */
export function MediaViewer(p: MediaViewerProps) {
  if (!p.open) return null;
  return (
    <Suspense fallback={null}>
      <Impl {...p} />
    </Suspense>
  );
}
